<template>
  <Modal
    :class="{ 'rtl--container': isArSite }"
    :maskClosable="false"
    :visible="visible"
    :footer="null"
    width="458px"
    @cancel="onClose"
  >
    <div class="language-selector-dialog-container">
      <p class="language-selctor-title">{{ $t('global.selectLanguage') }}</p>
      <div class="tips-wrapper">
        <img class="bulb-icon" src="/image/icon/tips-bulb.svg">
        <span>{{ $t('global.languageTips') }}</span>
      </div>
      <CountryLanguage :label="$t('global.country')" v-model:value="state.country" @change="countryChange" :optionList="countryList" :option="{ label:'country', value: 'country' }" />
      <CountryLanguage :label="$t('global.language')" v-model:value="state.languageId" :optionList="state.languageList" :option="{ label:'languageComplete', value: 'id' }" />
      <div class="footer-botton">
        <Button @click=" e => onSubmit(e)">
            {{ $t('global.confirm') }}
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, reactive, computed } from 'vue'
import { CookieUtil } from '@/utils'
import { Modal } from 'ant-design-vue'
import { getAtModel } from '@/utils/atModel'
import { useStoreHooks } from '@/store/hook'
import { useHeaderHook } from '@/utils/moduleHooks/global'
import { updateUserInfo } from '@/request/api/user'
import { LanguageItem } from '@/interface'
import CountryLanguage from '@/components/form/select/select.vue'
import { Button } from '@/components/common'

export default defineComponent({
  components: {
    Modal,
    CountryLanguage,
    Button
  },
  props: {
    visible: Boolean
  },
  emits: ['update:visible', 'close', 'feedback'],
  setup (props, ctx) {
    const { state: _state, getters, commit } = useStoreHooks()
    const {
      getRelatedCertificationInfo
    } = useHeaderHook()
    const isArSite = computed(() => _state.global.isArSite)
    const countryList = computed(() => _state.global.countryList)
    const currentLangKey = computed(() => _state.global.currentLangKey)
    const isLogin = getters['global/isLogin']
    const currentInfo = countryList.value.find(item => item.languageList.find(i => i.id === currentLangKey.value))
    const currentLanguageCountry = computed(() => {
      const index = _state.global.currentLangKey
      const item = _state.global.languageList.find(i => i.id === index)
      return item || {} as LanguageItem
    })
    const state = reactive({
      point: 0,
      feedback: '',
      country: currentInfo?.country || '',
      language: currentLanguageCountry.value.languageComplete,
      languageId: currentLangKey.value,
      languageList: currentInfo?.languageList || []
    })

    return {
      state,
      isArSite,
      countryList,
      currentLangKey,
      countryChange (val: any) {
        const currentInfo = countryList.value.find((item) => item.country === val)
        state.languageList = currentInfo?.languageList || []
        state.languageId = state.languageList[0].id
        state.language = state.languageList[0].languageComplete
      },
      onSubmit (e: Event) {
        getAtModel().doActionEvent(`header::button::${state.language}`, e)
        CookieUtil.setCookie('languageCheckedId', state.languageId + '', CookieUtil.FORMAT_TIME.YEAR)
        if (isLogin) {
          const userInfo = {
            ..._state.global.userInfo,
            languageId: state.languageId as number
          }
          updateUserInfo(userInfo).then(res => {
            if (res.code === 200) {
              commit('global/setUserInfo', userInfo)
              // location.href = `/${window.prefix}/`
            }
          }).finally(() => {
            getRelatedCertificationInfo(state.languageId as number)
          })
        } else {
          getRelatedCertificationInfo(state.languageId as number)
          // location.href = `/${window.prefix}/`
        }
      },
      onClose () {
        CookieUtil.setCookie('languageCheckedId', currentLangKey.value + '', CookieUtil.FORMAT_TIME.YEAR)
        ctx.emit('update:visible', false)
        ctx.emit('close')
      }
    }
  }
})
</script>

<style lang="less" scoped>
.language-selector-dialog-container {
  width: 100%;
  padding: 20px 30px;
  .language-selctor-title {
    font-weight: 700;
    font-size: 16px;
    color: #333;
    margin-bottom: 24px;
  }
  .tips-wrapper {
    width: 100%;
    background: #FCF6E4;
    border: 1px solid rgb(255, 216, 66);
    display: flex;
    align-items: flex-start;
    padding: 12px;
    font-size: 14px;
    color: #333;
    margin-bottom: 24px;
    .bulb-icon {
      width: 24px;
      margin-right: 8px;
    }
  }
  .footer-botton {
    display: flex;
    justify-content: center;
  }
}

.rtl--container {
  .language-selector-dialog-container .tips-wrapper .bulb-icon {
    margin-right: 0;
    margin-left: 8px;
  }
  .language-selector-dialog-container {
    .language-item-wrapper {
      .flag-icon {
        margin-right: 0;
        margin-left: 12px;
      }
      .down-wrap {
        right: auto;
        left: 0px;
      }
    }
  }
}
</style>
